import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=7f01fc0c&scoped=true"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=7f01fc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01fc0c",
  null
  
)

export default component.exports